import React from 'react';
import ReactDOM from 'react-dom/client';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const theme = createTheme({
  palette: {
    primary: { main: '#4E28B5', light: '#7C5CD6', dark: '#341C7A', contrastText: '#ffffff' },
    reverse: { main: '#ff6b6b', light: '#FF8F66', dark: '#CC4E1F', contrastText: '#ffffff' },
    ghost: { main: '#aaaaaa', light: '#aaaaaa', dark: 'aaaaaa', contrastText: '#ffffff' },
    background: { default: '#F7F6FB' },
  },
  shape: { borderRadius: 12 },
  typography: {
    fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
    h1: { fontFamily: '"Sora", "Inter", sans-serif', fontWeight: 700 },
    h2: { fontFamily: '"Sora", "Inter", sans-serif', fontWeight: 700 },
    h3: { fontFamily: '"Sora", "Inter", sans-serif', fontWeight: 700 },
    h4: { fontFamily: '"Sora", "Inter", sans-serif', fontWeight: 700 },
    h5: { fontFamily: '"Sora", "Inter", sans-serif', fontWeight: 600 },
    h6: { fontFamily: '"Sora", "Inter", sans-serif', fontWeight: 600 },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: { borderRadius: 999, textTransform: 'none', fontWeight: 600, paddingLeft: 20, paddingRight: 20 },
      },
    },
    MuiChip: {
      styleOverrides: { root: { fontWeight: 600 } },
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <App />
    </ThemeProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
